import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export const checkAndAddVideo = async (art, userId) => {
  const videoRef = doc(db, "videos", art.id);
  const videoDoc = await getDoc(videoRef);

  if (videoDoc.exists()) {
    return { exists: true };
  }

  const videoData = {
    createdAt: serverTimestamp(),
    description: art.description,
    thumbnail: `${art.location.cdnUrl}/thumbnail_master.png`,
    title: art.title,
    url: `${art.location.cdnUrl}/_main.mp4`,
    userId,
  };

  await setDoc(videoRef, videoData);

  return { exists: false };
};

export const getArtSale = async (artId, saleId) => {
  // Retrieve the API URL from environment variables
  const apiUrl = process.env.REACT_APP_GET_ART_SALE_URL;

  if (!apiUrl) {
    throw new Error("API URL is not defined in environment variables.");
  }

  // Retrieve the authResponseData from localStorage
  const authDataString = localStorage.getItem("authResponseData");

  if (!authDataString) {
    throw new Error("No authentication data found in localStorage.");
  }

  let authData;
  try {
    authData = JSON.parse(authDataString);
  } catch (parseError) {
    console.error(
      "Error parsing authResponseData from localStorage:",
      parseError
    );
    throw new Error("Invalid authentication data format.");
  }

  const token = authData.token;

  if (!token) {
    throw new Error("Authentication token is missing in authResponseData.");
  }

  // Construct the request body
  const requestBody = {
    Id: saleId,
    ArtworkId: artId,
    SellerId: "",
    IsPrimarySale: true,
    SellAsOne: false,
    SaleComplete: false,
    IsDraft: true,
    IsPause: false,
    UploadedByArtist: false,
    Shares: {
      PricePerShare: 0,
      InitialValue: 0,
      TotalShares: 0,
    },
  };

  try {
    // Make the POST request using fetch
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(requestBody),
    });

    // Check if the response status is OK (status code 2xx)
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `API request failed with status ${response.status}: ${errorText}`
      );
    }

    // Parse and return the JSON response
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error in getArtSale:", error);
    throw error; // Propagate the error to be handled by the caller
  }
};
